var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"section-header--terminal"},[(_vm.props.icon)?_c('i',{staticClass:"icon section-header__icon--terminal",class:_vm.props.icon}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"section-header__title--terminal"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d69e052","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/terminal/app/modules/shared/components/SectionHeader.vue
// module id = 1927
// module chunks = 0